module.exports = __webpack_public_path__ + "img/exch.9a55ea12.svg";